<template>
  <div>
    <div class="left_tree" v-show="showLeft">
      <a-spin :spinning="treeSpin" style="height: 100%">
        <div>
          <a-radio-group v-model="type" @change="handleChange">
            <a-radio-button value="dept">
              部门
            </a-radio-button>
            <a-radio-button value="customer">
              员工
            </a-radio-button>
          </a-radio-group>
          <vxe-button @click="closeAll" style="margin-top: 12px">清空</vxe-button>
        </div>
        <div class="tree-box" v-if="type === 'dept'">
          <a-tree
              v-model="checkedKeys"
              :show-icon="true"
              checkable
              :expanded-keys="expandedKeys"
              :auto-expand-parent="autoExpandParent"
              :selected-keys="selectedKeys"
              :tree-data="treeData"
              :selectable="false"
              :replaceFields="{children:'children', title:'deptName', key:'deptId'}"
              @expand="onExpand"
              @check="onSelect"
          >
            <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
            <a-icon type="cluster" slot="region" style="color:#52c41a"/>
          </a-tree>
        </div>
        <div class="tree-box" v-if="type === 'customer'">
          <Tree :list="treeData" :selectedUser="selectedUser" :userName="''" :detph="0"
                @change="checkedUser"></Tree>
        </div>
      </a-spin>
    </div>
    <div class="right_table" :class="{showLeft:!showLeft}">
<!--      2023 2/16侧边信息按钮注释 优化需求  筛选项新增经销商和经理部-->
<!--      <a-icon type="left-circle" class="close" @click="showLeft = false" v-if="showLeft"/>-->
<!--      <a-icon type="right-circle" class="close" @click="showLeft = true" v-else/>-->
      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :pager-config="pagerConfig"
          :form-config="formConfig"
          :url="url"
          :columns="columns"
          :checkbox-config="checkboxConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :export-config="exportConfig"
          ref="grid"
          :other-params="{
            startDate,endDate,isFollowCust,regionId,dealerId,userId,deptId
          }"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
          @toolbar-delData="delRow"
      >
        <template v-slot:[toolbarConfig.templatelSlots]>
          <!--          <vxe-button @click="synchronization()">同步</vxe-button>-->
          <!--          <vxe-button @click="chooseOpenPop('sharePeople')">共享人</vxe-button>-->
          <!--          <vxe-button @click="chooseOpenPop('followUpPeople')">跟进人</vxe-button>-->
          <!--          <vxe-button @click="sign(1)">标记老友</vxe-button>-->
          <!--          <vxe-button @click="sign(0)">取消标记</vxe-button>-->
          <!--          <vxe-button @click="showCustomerList">合并客户</vxe-button>-->
        </template>
        <!--        <template v-slot:operate="{row}">-->
        <!--          <div>-->
        <!--            <a-icon type="exclamation-circle" v-if="row.isRepeat === 1" @click.stop="repeat(row)"-->
        <!--                    style="color: red;font-size: 16px;margin-right: 6px"/>-->
        <!--            <span>{{ row.custNo }}</span>-->
        <!--          </div>-->
        <!--        </template>-->
      </x-grid>
    </div>
    <!--  弹出层  -->
    <!--    <popModal title="共享人" :pop-config="popConfig.sharePeople">-->
    <!--      <sharePeople-->
    <!--          ref="sharePeople"-->
    <!--          :type="'sharePeople'"-->
    <!--          :mainRowId="popConfig.sharePeople.id"-->
    <!--          :row="popConfig.sharePeople.row"-->
    <!--          @closePop="closePopAndRefresh"-->
    <!--      ></sharePeople>-->
    <!--    </popModal>-->

    <!--  弹出层  -->
    <!--    <popModal title="跟进人" :pop-config="popConfig.followUpPeople">-->
    <!--      <followUpPeople-->
    <!--          ref="followUpPeople"-->
    <!--          :type="'followUpPeople'"-->
    <!--          :mainRowId="popConfig.followUpPeople.id"-->
    <!--          :row="popConfig.followUpPeople.row"-->
    <!--          @closePop="closePopAndRefresh"-->
    <!--      ></followUpPeople>-->
    <!--    </popModal>-->

    <!--  弹出层  -->
    <!--    <popModal title="选择合并人" :pop-config="popConfig.selectCustomer">-->
    <!--      <selectCustomer-->
    <!--          ref="selectCustomer"-->
    <!--          :type="'selectCustomer'"-->
    <!--          :custId="customerData.custId"-->
    <!--          @closePop="closePopAndRefresh"-->
    <!--          @choose="chooseCust"-->
    <!--      ></selectCustomer>-->
    <!--    </popModal>-->


    <!--    <a-modal-->
    <!--        title=""-->
    <!--        v-model="visible"-->
    <!--        :footer="null"-->
    <!--        :closeble="true"-->
    <!--        style="text-align: center"-->
    <!--    >-->
    <!--      <p>该客户与"{{ repeatData.custName }}"客户重复</p>-->
    <!--      <a-button type="primary" @click="goMerge">去合并</a-button>-->
    <!--    </a-modal>-->

    <!--    <a-modal-->
    <!--        title="合并客户"-->
    <!--        v-model="merge"-->
    <!--        :footer="null"-->
    <!--        :closeble="true"-->
    <!--        :width="600"-->
    <!--    >-->
    <!--      <a-radio-group v-model="value">-->
    <!--        <a-radio :value="1">主数据-->
    <!--          <div class="item">-->
    <!--            <div>客户名称:{{ customerData.custName }}</div>-->
    <!--            <div>电话:{{ customerData.mobile }}</div>-->
    <!--            <div>企业名称:{{ customerData.companyName }}</div>-->
    <!--            <div>跟进人:{{ customerData.userName }}</div>-->
    <!--          </div>-->
    <!--        </a-radio>-->
    <!--        <a-radio :value="2">主数据-->
    <!--          <div class="item">-->
    <!--            <div>客户名称:{{ repeatData.custName }}</div>-->
    <!--            <div>电话:{{ repeatData.mobile }}</div>-->
    <!--            <div>企业名称:{{ repeatData.companyName }}</div>-->
    <!--            <div>跟进人:{{ repeatData.userName }}</div>-->
    <!--          </div>-->
    <!--        </a-radio>-->
    <!--      </a-radio-group>-->
    <!--      <div style="margin-bottom: 12px">选取主数据后，其他客户信息会被删除且不可恢复，请谨慎选择！</div>-->
    <!--      <div style="text-align: center">-->
    <!--        <a-button type="primary" @click="mergeCustomer">合并</a-button>-->
    <!--      </div>-->
    <!--    </a-modal>-->

  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";
// import sharePeople from "@/pages/web/client/customer/list/sharePeople";
// import followUpPeople from "@/pages/web/client/customer/list/followUpPeople";
// import selectCustomer from "@/pages/web/client/customer/list/selectCustomer";
import {XEUtils} from "@/utils/common/FormBase";
import Tree from "@/components/picker/Tree";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
// import detailForm from "@/pages/web/client/haveCar/haveCar";
import {dataApi} from "@/services/client/haveCar";
import {mapMutations} from "vuex";

const fac = XGrid.factory;

//列表接口
const url = api.client.SAVECAR;

//主键
const rowId = "vehicleId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("clueId", "线索ID", 100, "center"),
  fac.makeColumn("poolId", "公海线索ID", 100, "center"),
  fac.makeColumn("regionName", "经理部", 100, "center"),
  fac.makeColumn("dealerName", "经销商", 100, "center"),
  fac.makeColumn("userName", "销售顾问", 140, "center"),
  fac.makeColumn("custName", "客户名称", 140),
  fac.makeColumn("mobile", "手机号", 140, "center"),
  fac.makeColumn("clueSourceName", "线索来源", 140, "center"),
  fac.makeColumn("clueCreateDate", "线索创建时间", 140, "center"),
  fac.makeColumn("buyCarDate", "订车时间", 140, "center"),
  fac.makeColumn("brandName", "意向品牌", 140, "center"),
  fac.makeColumn("strainName", "品系", 140, "center"),
  fac.makeColumn("modelCode", "车型代码", 140, "center"),
  fac.makeColumn("batholithNo", "底盘号", 140, "center"),
  fac.makeColumn("lastReportDate", "最后一次跟进时间", 140, "center"),
  fac.makeColumn("purchaseDate", "销售时间", 140, "center"),
  fac.makeColumn("orderNo", "订单编号", 140, "center"),

  // fac.makeColumn({
  //   field: "isRepeat",
  //   title: "是否重复",
  //   width: 0,
  //   align: 'center',
  //   visible: false
  // }),
];

const formConfig = fac.makeFormConfig(columns, [
  {field: "custName"},//客户名称
  {field: "mobile"},//手机号
  {
    field: "regionId",
    // 'customSearch': true,
    title: "经理部",
    type: "select",
    options: [],
  },
  {
    field: "dealerName",
    // 'customSearch': true,
    title: "经销商",
    type: "search-select",
    options: [],
  },
  {
    field: "sourceId",
    title:"线索来源",
    type: "select",
    options: [],
  },//线索来源
  // {field: "sourceName",
  //   type: "select",
  //   options: [],
  // },//客户来源
  // {
  //   field: 'createDate',
  //   title: "创建时间",
  //   type: 'dateRange',
  // },//添加时间
  {
    field: "clueCreateDate",
    type: 'dateRange',
  },//线索创建时间
  {
    field: "buyCarDate",
    type: 'dateRange',
  },//订车时间
  {
    field: "brandId",
    title:"意向品牌",
    type: "select",
  },//品牌
  {
    field: "strainId",
    title:"品系",
    type: "select",
  },//品系
  {field: "modelCode"},//车型代码
  {field: "batholithNo"},//底盘号
  {field: "userName"},//销售顾问
  {field: "purchaseDate",
    type: "dateRange",
  },// 销售时间
  {field: "clueId"},
  {field: "poolId", title: "公海线索ID"}
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);
const popConfig = fac.makePopConfig(["password", "merchantsAuthorization", "sharePeople", "followUpPeople", 'selectCustomer']);

async function loadBaseData() {

  this.natureOptions = await loadBaseCodeData('CD300004')//客户性质
  this.cstegoryOptions = await loadBaseCodeData('CD300003')//客户类型
  this.clueSourceOptions = await loadBaseCodeData('CD200004')//线索来源

  //了解柳汽主要渠道
  this.clueSourceOptions = this.clueSourceOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.clueSourceOptions = [{
    value: '',
    label: '全部'
  }].concat(this.clueSourceOptions);
  this.loadSearchOption({
    sourceId: this.clueSourceOptions,
  })
  let region = { //经理部
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {//经销商
    isRegion: 0,
    isDealer: 1
  }
  //经理部
  this.regionOptions = await dataApi.selection(region);
  //经销商
  this.dealerOptions = await dataApi.selection(dealer);
  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);

  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptName
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);
  this.loadSearchOption({
    dealerName: this.dealerOptions,
    regionId: this.regionOptions,
  })
  // 客户性质下拉处理
  this.natureOptions = this.natureOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.natureOptions = [{
    value: '',
    label: '全部'
  }].concat(this.natureOptions);
  this.loadSearchOption({
    custNatureName: this.natureOptions,
  })
  //客户类型下拉处理
  this.cstegoryOptions = this.cstegoryOptions.map(v => {
    return {
      label: v.label,
      value: v.label
    }
  })
  this.cstegoryOptions = [{
    value: '',
    label: '全部'
  }].concat(this.cstegoryOptions);
  this.loadSearchOption({
    custCategoryName: this.cstegoryOptions,
  })
  //品系
  this.strainOptions = await dataApi.selectionStrain();//品系
  this.strainOptions = this.strainOptions.data.map(v => {
    return {
      label: v.strainName,
      value: v.strainId
    }
  })
  this.strainOptions = [{
    value: '',
    label: '全部'
  }].concat(this.strainOptions);
  this.loadSearchOption({
    strainId: this.strainOptions,
  })
  // 品牌
  let commCodeData =  await dataApi.getCommCode();//
  console.log(commCodeData);
  this.brandOptions = commCodeData.data.brand.map(v => {
    return {
      label: v.code_name,
      value: v.code_id
    }
  })
  this.brandOptions = [{
    value: '',
    label: '全部'
  }].concat(this.brandOptions);
  this.loadSearchOption({
    brandId: this.brandOptions,
  })
}


export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    // detailForm,
    // sharePeople,
    // followUpPeople,
    // selectCustomer,
    Tree
  },
  watch: {
    $route: {
      handler: function (newValue, oldValue) {
        if (oldValue && newValue.path === '/client/haveCar') {
          this.startDate = this.$store.state.setting.startTime || null
          this.endDate = this.$store.state.setting.endTime || null
          this.$nextTick(() => {
            this.refresh()
          })
        } else {
          this.setStartTime(null)
          this.setEndTime(null)
        }
      },
      immediate: true,
    },
    'formData.regionId'(val) { //经理部 联动经销商
      this.formData.dealerName =null
      this.getDealerData(val)
    }
  },
  computed: {
    // ...mapState("account", { currUser: "user" }),
  },
  data() {
    return {
      popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList: [],
      natureOptions: [],
      cstegoryOptions: [],
      strainOptions: [],
      regionOptions: [],
      dealerOptions: [],
      visible: false,
      merge: false,
      customerData: {},
      repeatData: {},
      value: 1,
      startDate: this.$store.state.setting.startTime || null,
      endDate: this.$store.state.setting.endTime || null,
      isFollowCust: this.$route.query.isFollowCust,
      regionId: '', dealerId: '', userId: '', deptId: '',
      //角色树
      autoExpandParent: false,
      defaultExpandedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      deptList: [],
      treeData: [],
      selectedUser: [],
      treeSpin: false,
      showLeft: false,
      type: 'dept',
      formData:null,//筛选项
    };
  },
  mounted() {
    this.init();
    this.formData = this.$refs.grid.$refs.xGrid.formData; //获取筛选项
  },
  methods: {
    ...mapMutations('setting', ['setStartTime', 'setEndTime']),
    loadBaseData,
    async synchronization() {
      this.loading(true);
      await dataApi.synchronization().then(res => {
        this.$message.success(res.msg);
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh();
    },//同步
    async sign(isOldFriend) {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length < 1) {
        this.$message.error('请至少选择一条数据');
        return false;
      }

      this.loading(true);
      let rowsList = rows.map((item) => {
        return {
          vehicleId: item.vehicleId,
          isOldFriend: isOldFriend,
        }
      })
      await dataApi.sign(rowsList).then(() => {
        if (isOldFriend == 1) {
          this.$message.success('标记成功');
        } else {
          this.$message.success('取消标记成功');
        }
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh();
    },//是否老友
    showCustomerList() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length !== 1 && rows.length !== 2) {
        this.$message.error('请选择一条或者两条数据');
        return false;
      }
      if (rows.length === 1) {
        this.customerData = rows[0]
        this.chooseOpenPop('selectCustomer')
      } else {
        this.customerData = rows[0]
        this.repeatData = rows[1]
        this.value = 1
        this.merge = true
      }
    },//合并客户
    chooseCust(row) {
      this.repeatData = row
      this.closePop('selectCustomer')
      this.merge = true
    },//选择合并人
    repeat(row) {
      this.customerData = row
      dataApi.getRepeat(row.vehicleId).then(res => {
        if (res.code === 200) {
          this.repeatData = res.data[0]
          this.visible = true
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    goMerge() {
      this.value = 1
      this.merge = true
    },//去合并
    mergeCustomer() {
      let params = {
        mainvehicleId: this.customerData.vehicleId,
        mergevehicleId: this.repeatData.vehicleId
      }
      if (this.value === 2) {
        params.mainvehicleId = this.repeatData.vehicleId
        params.mergevehicleId = this.customerData.vehicleId
      }
      dataApi.merge(params).then(res => {
        if (res.code === 200) {
          this.$message.success('合并成功');
          this.merge = false
          this.visible = false
          this.refresh();
        } else {
          this.$message.error(res.msg)
        }
      })
    },//合并
    init() {
      dataApi.popSelect().then(res => {
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
      })
    },
    handleChange() {
      this.closeAll()
      this.init()
    },
    closeAll() {
      this.checkedKeys = []
      this.userId = ''
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      XEUtils.mapTree(this.treeData, item => {
        if (item.userList) {
          item.userList.map(user => {
            user.checked = false
          })
        }
        return item
      })
      this.selectedUser = []
      this.$nextTick(() => {
        this.refresh()
      })
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []
      checkedNodes.forEach(item => {
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
        } else {
          deptId.push(item.key)
        }
      })
      this.regionId = regionId.toString()
      this.dealerId = dealerId.toString()
      this.deptId = deptId.toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
      }
      this.userId = this.selectedUser.map(item => {
        return item.userId
      }).toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },
    /**
     * 经理部 经销商联动数据
     * @param id
     * @return {Promise<void>}
     */
    async getDealerData(id) {
      let dealer = {
        isRegion: 0,
        isDealer: 1,
        'filter.eq.parentId': id,
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);
      this.loadSearchOption({
        dealerName: this.dealerOptions,
      })
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}
</style>
